import { WeekdayPicker } from '@components/toggle-group';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormWeekdayPickerProps<T = unknown> = Omit<
  FormFieldProps<
    {
      onChange: (value: unknown) => void;
      defaultValue?: number[];
      minSelectedTooltip?: string;
    },
    T
  >,
  'label'
>;

export function FormWeekdayPicker<T>(props: FormWeekdayPickerProps<T>) {
  const { value, onChange } = useFormField<number[]>({ label: '', ...props });
  return (
    <WeekdayPicker
      defaultValue={props.defaultValue}
      minSelectedTooltip={props.minSelectedTooltip}
      value={value}
      onChange={onChange}
    />
  );
}
